module.exports = __webpack_public_path__ + "img/4.469c8a77.jpg";